import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import SlideInModalLoader from 'syf-component-library/ui/atoms/Loader/Skeleton/SlideInModalLoader';
export const PaddedSlideInModalLoader = styled(SlideInModalLoader) `
  padding: ${spacing.large}px ${spacing.xxlarge}px;
`;
